import { ReactNode } from 'react';
import ProtectedRoute from '@/components/auth/protected-route';
import Sidebar from './sidebar';
import Topbar from './topbar';

export default function DashboardLayout({ children }: { children: ReactNode }) {
  return (
    <ProtectedRoute>
      <div className="min-h-screen bg-gray-100">
        <Topbar />
        <Sidebar />
        <main className="pt-16 lg:pl-72">
          <div className="p-6 md:p-8">{children}</div>
        </main>
      </div>
    </ProtectedRoute>
  );
}
